export default __webpack_public_path__ + "static/media/VennHeart.5201d8a7.svg";